import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import type { RootState } from '@/state/store';
import { messages, DEFAULT_LOCALE } from './messages';
import en from './messages/en';

export function IntlProviderWrapper({ children }: Readonly<{ children: React.ReactNode }>) {
  const locale = useSelector((state: RootState) => state.auth.locale) || DEFAULT_LOCALE;
  // Merge over English so any key missing from a locale falls back to English
  // rather than rendering a raw message id.
  const localeMessages = { ...en, ...messages[locale] };

  return (
    <IntlProvider locale={locale} messages={localeMessages} defaultLocale={DEFAULT_LOCALE}>
      {children}
    </IntlProvider>
  );
}
